import router from "next/router";

import { translationsContent } from "../../../../../localization/translations";
import { useLanguage } from "../../../../../store/lang.context";
import { translate } from "../../../../../utils/translate";
import CheckBox from "../../../../ui/input/CheckBox";
import classes from "./club.module.scss";

interface Props<T, K extends keyof T> {
  identifier: K;
  onChange: (identifier: K, value: boolean) => void;
}

const Club = <T, K extends keyof T>({ onChange, identifier }: Props<T, K>) => {
  const { language } = useLanguage();

  const routeToRules = () => {
    const lang = localStorage.getItem("language");
    switch (lang) {
      case "fr":
        router.push("/reglement-la-fidelite");
        break;
      case "en":
        router.push("/en/regulation-the-fidelity");
        break;
      case "es":
        router.push("/es/reglamento-el-fidelite");
        break;
      case "nl":
        router.push("/nl/reglement-de-fidelite");
        break;
    }
  };

  return (
    <div className={classes.container}>
      <span className={classes.span} onClick={routeToRules}>
        {translate(translationsContent, "fidelityLink", language)}
      </span>
      <div className={classes.checkbox}>
        <CheckBox<T, K>
          label={`${translate(translationsContent, "clubHeader1", language)}`}
          identifier={identifier}
          onChange={onChange}
          defaultChecked={false}
        />
      </div>
    </div>
  );
};

export default Club;
